<template>
  <div class="wrap" id="giftDBL">
    <div class="header">
      <h2 class="st_title">
        <img src="@/assets/占星小鋪/friend.svg" alt="" />
        合盘设定
      </h2>
      <div class="header__addFriendBtn hidden-pad-down" @click="addFriend()">
        <img src="../../assets/占星小鋪/add friend.svg" alt="" />
      </div>
    </div>

    <!-- 設定合盤組合 -->
    <div class="buyDBL__main">
      <h3>设定合盘组合</h3>
      <div class="buyDBL__main__buyGroup">
        <div class="select__show" v-for="(set, index) in buySet" :key="index">
          <SelectBar
            :items="selectFriendsList"
            :value="set.AstrolabeId1"
            @change="
              (astrolabeFileId) => {
                set.AstrolabeId1 = astrolabeFileId;
              }
            "
            :disableItemValue="set.AstrolabeId2"
          ></SelectBar>

          <div class="select__show__pic">
            <img src="@/assets/雙人合盤/好友分隔.svg" alt="" />
          </div>
          <SelectBar
            :items="selectFriendsList"
            :value="set.AstrolabeId2"
            @change="
              (astrolabeFileId) => {
                set.AstrolabeId2 = astrolabeFileId;
              }
            "
            :disableItemValue="set.AstrolabeId1"
          ></SelectBar>
        </div>
      </div>
    </div>

    <!-- 前往結帳按鈕 -->
    <div class="nextBtn" :class="{ notReady: !verify }" @click="next()">
      确认
    </div>

    <!-- 好友列表dialog -->
    <SelectFriendsDialog
      v-if="showSelectFriendsDialog"
      :friendsList="List_all"
      @toSelect="({ item, is_checked }) => selectHandler(item, is_checked)"
      @cancel="showSelectFriendsDialog = false"
    ></SelectFriendsDialog>

    <!-- 新增好友dialog -->
    <CreateFriendDialog
      v-if="showCreateFriendDialog"
      @success="createFriendSuccess"
      @cancel="createFriednCancel"
    ></CreateFriendDialog>
  </div>
</template>

<script>
import FriendCardDBL from "../../components/雙人合盤/FriendCardDBL.vue";
import SelectFriendsDialog from "../../components/雙人合盤/SelectFriendsDialog.vue";
import CreateFriendDialog from "../../components/彈窗/FriendCreateDialog.vue";
import SelectBar from "../../components/SelectBar.vue";
import { EventBus } from "@/main.js";
export default {
  components: {
    FriendCardDBL,
    SelectFriendsDialog,
    CreateFriendDialog,
    SelectBar,
  },
  data() {
    return {
      List_all: [],
      List_filter: [],
      filterKey: "",
      typeSelect: "couple", //null
      showSelectFriendsDialog: false,
      showCreateFriendDialog: false,
      buySet: [], //合盤設定列表
    };
  },
  async created() {
    await this.init();
    this.buySet = [
      {
        AstrolabeId1: this.selfId,
        AstrolabeId2: "",
      },
    ]; //預設一組合盤

    EventBus.$on("add-friend-success", () => {
      this.init();
    });
  },
  computed: {
    selfId() {
      return this.$store.state.userData.AstrolabeFriendLists.find(
        (item) => item.Relationship == "R0" && item.IsBelongToMember
      ).AstrolabeFileId;
    },
    selectFriendsList() {
      return this.List_all.map((item) => {
        return {
          label: item.Name,
          value: item.AstrolabeFileId,
        };
      });
    },
    verify() {
      return (
        this.typeSelect &&
        this.buySet.every((item) => {
          return item.AstrolabeId1 && item.AstrolabeId2;
        })
      );
    },
    productInfoSynastry() {
      return this.$store.state.productList.find(
        (item) => item.Code == "Synastry"
      );
    },
  },
  methods: {
    async init() {
      try {
        let data = await this.$API.Get_MemberInfo();
        window.localStorage["loginIndex"] = data.Data.MemberId;
        this.$store.commit("set_userData", data.Data);
      } catch (e) {
        console.error("[ADD DBL] Get_MemberInfo error", e);
      }
      this.List_all = this.$store.state.userData.AstrolabeFriendLists.map(
        (item) => {
          item.is_checked = false;
          return JSON.parse(JSON.stringify(item));
        }
      ).sort((a, b) => {
        return a.ProfilePhotoSrc.split("/")[3].localeCompare(
          b.ProfilePhotoSrc.split("/")[3]
        );
      });
      this.List_filter = [...this.List_all];
    },
    async next() {
      let giftId = this.$route.params.GiftID;
      let AstrolabeId1 = this.buySet[0].AstrolabeId1;
      let AstrolabeId2 = this.buySet[0].AstrolabeId2;
      if (!giftId || !AstrolabeId1 || !AstrolabeId2) {
        console.log("data id not exist");
      }

      let Parameters = JSON.stringify({
        SynastryDtos: [
          {
            AstrolabeFileIds: [parseInt(AstrolabeId1), parseInt(AstrolabeId2)],
          },
        ],
      });
      try {
        let res = await this.$API.PATCH_AstrolabeFile(giftId, { Parameters });
        if (!res) throw new Error("回應失敗");
        window.location = `/member/giftBox`;
      } catch (e) {
        console.log("data id not exist", e);
        this.$imageNotice({
          imageIdx: 0,
          title: "啟用失敗",
          okText: "我知道了",
          desc: `服務忙線中，請稍後再試`,
          okEvent: () => {
            this.init();
          },
        });
      }
    },

    /* 新增好友相關 Start */
    addFriend() {
      this.showCreateFriendDialog = true;
    },
    createFriendSuccess() {
      this.showCreateFriendDialog = false;
      this.init();
    },
    createFriednCancel() {
      this.showCreateFriendDialog = false;
    },
    /* 新增好友相關 End */
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";
@import "@/scss/toast.scss";
@import "@/scss/dialog.scss";
.wrap#giftDBL {
  padding-top: 62px;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto 88px;
  min-height: 100vh;
  letter-spacing: 0.08em;
  @include pad {
    padding: 20px 23px 0;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include pad {
      flex-direction: column;
      align-items: center;
    }
    h2.st_title {
      font-weight: 500;
      font-size: 40px;
      color: $theme-color-2;
      display: flex;
      align-items: center;
      margin-right: auto;
      line-height: 1;
      @include pad {
        display: none;
      }
      img {
        width: 54px;
        margin-right: 16px;
        @include pad {
          width: 30px;
          margin-right: 5px;
        }
      }
    }
    &__addFriendBtn {
      @include btn(40px, 40px, $theme-color-2, #fff);
      border-radius: 50%;
      margin-left: 30px;
      @include pad {
        margin-left: 20px;
      }
      img {
        width: 90%;
      }
    }
  }
  //主要設定面板
  .buyDBL__main {
    max-width: 602px;
    background: #f0f2f4;
    box-shadow: -4px -4px 16px rgba(238, 109, 175, 0.22), -4px -4px 10px rgba(238, 109, 175, 0.22),
      4px 4px 25px rgba(0, 0, 0, 0.15);
    border-radius: 100px;
    padding: 60px 87px;
    margin: 60px auto 40px;
    @include mobile {
      padding: 0;
      margin: 36px auto 72px;
      box-shadow: none;
    }
    h3 {
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.08em;
      text-align: left;
      font-weight: 700;
      color: #17445c;
      @include mobile {
        font-size: 20px;
        line-height: 36px;
      }
    }
    h4 {
      font-size: 16px;
      line-height: 28px;
      text-align: left;
      color: #9b9b9b;
      margin-top: 4px;
      @include mobile {
        font-size: 14px;
        line-height: 28px;
        margin-top: 0;
      }
    }
    .buyDBL__main__typeGroup {
      margin-top: 40px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
      line-height: 1;
      @include mobile {
        margin-top: 20px;
        gap: 13px;
      }
      div {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &__item {
        width: 95px;
        height: 134px;
        border-radius: 30px;
        box-shadow: -1.13px -1.13px 4.5px rgba(238, 109, 175, 0.22), -1.13px -1.13px 4.5px rgba(238, 109, 175, 0.22),
          2.25px 2.25px 6.75px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        user-select: none;
        transition: 0.3s;
        @include mobile {
          width: 72px;
          height: 102px;
        }
        &.active {
          box-shadow: 2px 2px 4px rgba(238, 109, 175, 0.22), inset 2px 2px 4px rgba(0, 0, 0, 0.15);
        }
        .checkbox-wrap {
          display: none; //隱藏checkbox
        }
        &__pic {
          width: 48px;
          margin-bottom: 12px;
          img {
            width: 48px;
          }
        }
      }
      &__title {
        font-size: 20px;
        color: #767676;
        @include mobile {
          font-size: 14px;
        }
      }
    }
    .buyDBL__main__buyGroup {
      margin-top: 40px;
      @include mobile {
        margin-top: 24px;
      }
    }
    .selectBar {
      min-width: 152px;
      @include mobile {
        min-width: 113px;
      }
    }
    .select__show {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
      margin: 0 auto 32px 0;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.06em;
      color: #767676;
      @include mobile {
        gap: 4px;
        margin: 0 auto 34px;
        font-size: 12px;
      }
      &__item {
        height: 40px;
        width: 136px;
        border-radius: 50px;
        padding: 0 8px;

        box-shadow: 2px 2px 4px rgba(238, 109, 175, 0.22), inset 2px 2px 4px rgba(0, 0, 0, 0.15);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
        line-height: 20px;
        color: #17445c;
        @include mobile {
          font-size: 14px;
        }
        &__text {
          width: calc(100% - 16px - 24px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-overflow: ellipsis;
          text-align: center;
          @include mobile {
            width: calc(100% - 16px - 20px);
          }
        }
        img {
          width: 24px;
          height: 24px;
          @include mobile {
            height: 20px;
            width: 20px;
          }
        }
      }
      &__pic {
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }
    }
    .select__addSynastrys {
      display: flex;
      align-items: center;
      gap: 15px;
      font-size: 16px;
      color: #9b9b9b;
      &__button {
        width: 28px;
        height: 28px;
        border-radius: 8.75px;
        background: #f0f2f4;
        box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22), -1px -1px 4px rgba(238, 109, 175, 0.22),
          2px 2px 6px rgba(0, 0, 0, 0.25);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 20px;
        }
      }
    }
    .select__show__delete img {
      width: 32px;
      cursor: pointer;
      @include mobile {
        width: 28px;
      }
    }
  }

  .buyDBLFriends {
    max-width: 1032px;
    margin: 0 auto;
    h2 {
      font-weight: 500;
      font-size: 28px;
      line-height: 58px;
      color: $theme-color-2;
      display: flex;
      align-items: center;
      margin-right: auto;
      @include pad {
        font-size: 16px;
      }
    }
    &__list {
      margin-top: 36px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      @include pad {
        justify-content: center;
      }
      &__item {
        width: 480px;
        margin-bottom: 60px;
        @include pad {
          margin-bottom: 36px;
        }
      }
    }
  }
}
.checkbox-wrap {
  margin-left: 20px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 1.6px;
  color: $secondary-color-3;
  position: relative;
  padding-left: 32px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* Hide the browser's default checkbox */
  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: -2px;
    transform: translateY(-50%);
    @include rect-s(20px, 20px, $theme-color-3, 3px);
    border: 1px solid #aaa;
    box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22), 2px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 5.5px;
      top: 1px;
      width: 7px;
      height: 13px;
      border: solid #fff;
      border-width: 0px 3px 3px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  input:checked ~ .checkmark {
    background-color: $theme-color-1;
    border: 1px solid $theme-color-1;
    &:after {
      display: block;
    }
  }

  @include pad {
    font-size: 14px;
    line-height: 1;
    letter-spacing: 0.56px;
    margin-left: 16px;
    padding-left: 28px;
    .checkmark {
      width: 16px;
      height: 16px;
      top: 0px;
      &:after {
        top: 0.5px;
        left: 4.5px;
        width: 6px;
        height: 10px;
        border-width: 0px 2px 2px 0;
      }
    }
  }
}
.nextBtn {
  @include btn-default(250px, 56px);
  margin: 40px auto 0;
  @include mobile {
    margin: 36px auto 0;
    @include btn-default(100%, 56px);
  }
  &.notReady {
    pointer-events: none;
  }
}

//訂單總計
.buyDBL__main__total {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 15px;
  margin-top: 24px;
  border-bottom: 1px solid #d8d8d8;
  @include mobile {
    padding-bottom: 10px;
    margin-top: 12px;
  }
  .total__info {
    .total__info__item {
      font-size: 18px;
      color: #767676;
      @include mobile {
        font-size: 16px;
      }
      span {
        color: #17445c;
      }
    }
  }
  .total__price {
    font-size: 16px;
    color: #17445c;
    font-weight: 700;
    @include mobile {
      font-size: 14px;
    }
    span {
      font-size: 40px;
      line-height: 1;
      color: #17445c;
      @include mobile {
        font-size: 32px;
      }
    }
  }
}
</style>
